module.exports = __webpack_public_path__ + "img/crypto-cny.d1052ca5.svg";